import styles from './contract-item-info-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { CheckboxLabel, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, TextField } from '@frontend-workspace/react-shared-lib';
import { IContractItemInfos } from '../../_models/contract-item-infos';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ContractItemInfoDialogProps {
  open: boolean,
  onClose: () => void,
  contractItemInfo: IContractItemInfos
}

export function ContractItemInfoDialog(props: ContractItemInfoDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t("addProducts.contractInfo")}
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column mb-3">
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.id}
                  fullWidth
                  label="Visma ID"
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.itemType}
                  fullWidth
                  label="Type"
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.nimbusProductCode}
                  fullWidth
                  label={t("addProducts.nimbusCode")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <div className='mb-3'>
            <TextField
              value={props.contractItemInfo.productName}
              fullWidth
              label={t("standard.name")}
              disabled
            />
          </div>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.productGroupName}
                  fullWidth
                  label={t("standard.groupName")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <div className='mb-3'>
            <TextField
              value={props.contractItemInfo.productName}
              fullWidth
              label={t("standard.productName")}
              disabled
            />
          </div>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.productGroupCode}
                  fullWidth
                  label={t("addProducts.nimbusGroupCode")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.recurringInventoryItemId}
                  fullWidth
                  label={t("addProducts.recurringInventoryItemId")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.setupInventoryItemId}
                  fullWidth
                  label={t("addProducts.setupInventoryItemId")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.recurringPrice}
                  fullWidth
                  label={t("standard.recurringPrice")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.setupPrice}
                  fullWidth
                  label={t("addProducts.setupPrice")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.startupItemId}
                  fullWidth
                  label={t("addProducts.startupItemId")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className='mb-3'>
                <TextField
                  value={props.contractItemInfo.seatsPerQuantity}
                  fullWidth
                  label={t("standard.seatsPerQuantity")}
                  disabled
                />
              </div>
            </Col>
          </Row>
          <div className='mb-1'>
            <CheckboxLabel
              label={t("standard.cloudLicensing")}
              checked={props.contractItemInfo.isNimbusLicense}
              disabled
            />
          </div>
          <div className='mb-1'>
            <CheckboxLabel
              label={t("standard.canSell")}
              checked={props.contractItemInfo.canSellNew}
              disabled
            />
          </div>
          <div className='mb-1'>
            <CheckboxLabel
              label={t("standard.academicVersion")}
              checked={props.contractItemInfo.isSchoolVersion}
              disabled
            />
          </div>
          <div className='mb-1'>
            <CheckboxLabel
              label={t("standard.additionalProduct")}
              checked={!!props.contractItemInfo.connectedItem}
              disabled
            />
          </div>
          {!!props.contractItemInfo.connectedItem &&
            <div className="mt-3">
              <CheckboxLabel
                label={t("addProducts.newLicense")}
                checked={props.contractItemInfo.connectedItem.newLicense}
                disabled
              />
              <TextField
                value={props.contractItemInfo.connectedItem.idOfConnected}
                fullWidth
                label={t("addProducts.idForNextItem")}
                disabled
              />
              <TextField
                value={props.contractItemInfo.connectedItem.requiredQuantity}
                fullWidth
                label={t("addProducts.quantityBeforeNextItem")}
                disabled
              />
            </div>
          }
        </div>
      </DialogContent>
      <DialogActions>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default ContractItemInfoDialog;